import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';

interface StepComponent {
  label: string;
  component: React.ReactNode;
}

interface CustomStepperProps {
  steps: StepComponent[];
  button?: object;
  handleNextStep?: () => void;
}

const CustomVerticalStepper: React.FC<CustomStepperProps> = ({ steps, button, handleNextStep }) => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };


  return (
    <Box width={'100%'}>
      <Stepper activeStep={activeStep} orientation={'vertical'}>
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel>
              {step.label}
            </StepLabel>
            <StepContent>
              {step.component}
              <Box sx={{ mb: 2, display: 'flex' }}>
                <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{ mt: 1, mr: 1 , display: index === steps.length - 1 ? 'none' : 'block'}}
                >
                 Tovább
                </Button>
                <Button
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1, display: index === 0 ? 'none' : 'block'}}
                >
                  Vissza
                </Button>
                <Button
                  variant="contained"
                  onClick={handleNextStep}
                  sx={{ mt: 1, mr: 1, display: index === steps.length - 1 ? 'block' : 'none', ...button}}
                >
                  Tovább a jelszó beállításához
                </Button>

              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomVerticalStepper;

